import { Sliders } from "../Sliders";
import { MoveTable } from "./MoveTable";
import { Region } from "./Region";
import { util } from "../../../lib/util/util";
export var OptimizedSliderState;
(function (OptimizedSliderState) {
    var SliderState = Sliders.SliderState;
    var chooseRandom = util.chooseRandom;
    OptimizedSliderState.SIZE = 27;
    OptimizedSliderState.tile_reflection_table = [
        0, 5, 10, 15, 20,
        1, 6, 11, 16, 21,
        2, 7, 12, 17, 22,
        3, 8, 13, 18, 23,
        4, 9, 14, 19, 24
    ];
    OptimizedSliderState.reflection_pairs = [
        [1, 5], [2, 10], [3, 15], [4, 20], [7, 11], [8, 16], [9, 21], [13, 17], [14, 22], [19, 23]
    ];
    function copy(state) {
        return new Uint8Array(state);
    }
    OptimizedSliderState.copy = copy;
    OptimizedSliderState.BLANK_INDEX = 25;
    OptimizedSliderState.LASTMOVE_INDEX = 26;
    OptimizedSliderState.SOLVED = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 24, 20]);
    const partial_moves = [
        /* -20 */ [0, -5, -10, -15, -20],
        /* -19 */ [],
        /* -18 */ [],
        /* -17 */ [],
        /* -16 */ [],
        /* -15 */ [0, -5, -10, -15],
        /* -14 */ [],
        /* -13 */ [],
        /* -12 */ [],
        /* -11 */ [],
        /* -10 */ [0, -5, -10],
        /* - 9 */ [],
        /* - 8 */ [],
        /* - 7 */ [],
        /* - 6 */ [],
        /* - 5 */ [0, -5],
        /* - 4 */ [0, -1, -2, -3, -4],
        /* - 3 */ [0, -1, -2, -3],
        /* - 2 */ [0, -1, -2],
        /* - 1 */ [0, -1],
        /*   0 */ [],
        /*   1 */ [0, 1],
        /*   2 */ [0, 1, 2],
        /*   3 */ [0, 1, 2, 3],
        /*   4 */ [0, 1, 2, 3, 4],
        /*   5 */ [0, 5],
        /*   6 */ [],
        /*   7 */ [],
        /*   8 */ [],
        /*   9 */ [],
        /*  10 */ [0, 5, 10],
        /*  11 */ [],
        /*  12 */ [],
        /*  13 */ [],
        /*  14 */ [],
        /*  15 */ [0, 5, 10, 15],
        /*  16 */ [],
        /*  17 */ [],
        /*  18 */ [],
        /*  19 */ [],
        /*  20 */ [0, 5, 10, 15, 20],
    ];
    function doMove(state, move) {
        const partials = partial_moves[move + 20];
        let blank = state[OptimizedSliderState.BLANK_INDEX];
        for (let i = 0; i < partials.length - 1; ++i) {
            state[blank + partials[i]] = state[blank + partials[i + 1]];
        }
        state[OptimizedSliderState.LASTMOVE_INDEX] = move + 20;
        state[state[OptimizedSliderState.BLANK_INDEX] = blank + move] = 24;
    }
    OptimizedSliderState.doMove = doMove;
    function fromState(state) {
        const blank = SliderState.blank(state);
        return new Uint8Array([...state, blank, 20]);
    }
    OptimizedSliderState.fromState = fromState;
    function reflect(state) {
        // Swap tiles on opposing side of the main diagonal
        for (const [a, b] of OptimizedSliderState.reflection_pairs) {
            const tmp = state[a];
            state[a] = state[b];
            state[b] = tmp;
        }
        // Update tile values to the reflected tile id
        for (let i = 0; i < 25; i++) {
            state[i] = OptimizedSliderState.tile_reflection_table[state[i]];
        }
        state[OptimizedSliderState.BLANK_INDEX] = OptimizedSliderState.tile_reflection_table[state[OptimizedSliderState.BLANK_INDEX]];
        state[OptimizedSliderState.LASTMOVE_INDEX] = OptimizedSliderState.move_translation_reflect[state[OptimizedSliderState.LASTMOVE_INDEX]] + 20;
    }
    OptimizedSliderState.reflect = reflect;
    function asState(state) {
        return [...state.slice(0, 25)];
    }
    OptimizedSliderState.asState = asState;
    function ramenShuffle(n = 100, state = OptimizedSliderState.fromState(SliderState.SOLVED)) {
        const table = new MoveTable(Region.empty(), false, true);
        return shuffle(table, n, state);
    }
    OptimizedSliderState.ramenShuffle = ramenShuffle;
    function shuffle(move_table, n = 100, state = OptimizedSliderState.fromState(SliderState.SOLVED)) {
        for (let i = 0; i < n; i++) {
            doMove(state, chooseRandom(move_table.get(state)));
        }
        return state;
    }
    OptimizedSliderState.shuffle = shuffle;
    OptimizedSliderState.move_translation_reflect = [
        -4, undefined, undefined, undefined, undefined, // -20
        -3, undefined, undefined, undefined, undefined, // -15
        -2, undefined, undefined, undefined, undefined, // -10
        -1, // -5
        -20, // -4
        -15, // -3
        -10, // -2
        -5, // -1
        0, //  0
        5, // 1
        10, // 2
        15, // 3
        20, // 4
        1, undefined, undefined, undefined, undefined, // 5
        2, undefined, undefined, undefined, undefined, // 10
        3, undefined, undefined, undefined, undefined, // 15
        4, // 20
    ];
})(OptimizedSliderState || (OptimizedSliderState = {}));
